import React from 'react'

export default function WorkCase({ imagesrc, name, stack, description, link }) {
    return (
        <div className="w-11/12 xl:w-4/6 flex-none laptop:flex mt-5 bg-white rounded-3xl border-2 border-solid border-slightgray m-auto">
            <div className="w-full laptop:w-4/6">
                <a href={link} target="_blank" ><img src={imagesrc}  alt={name} className=" rounded-tl-3xl rounded-tr-3xl laptop:rounded-tr-none laptop:rounded-bl-3xl" /></a>
            </div>
            <div className="justify-between flex flex-col laptop:text-left laptop:w-2/6 px-7 py-5">
                <div>
                    <h2 className="uppercase text-3xl font-semibold">{name}</h2>
                    <p className="font-medium text-xl mt-2" >{description}</p>
                    <p className="font-medium text-xl mt-2" > <strong className>Stack:</strong>{stack}</p>
                </div>
                <a href={link} target="_blank" className="btnHoverAnim mt-4 cursor-pointer uppercase font-bold"> <div></div> <p className="flex mr-5 text-base items-center">View project <img className="w-14 ml-5" src="arrow4.svg" alt="arrow" /></p></a>
            </div>
        </div>
    )
}
